import { Implementation } from "../../implementation.js"


export const KEYS: Implementation[ "KEYS" ] = {
  ACCOUNT_UCAN: "account-ucan",
  CID_LOG: "cid-log",
  SESSION: "session",
  UCANS: "permissioned-ucans",
}